import { render, staticRenderFns } from "./DefaultHome.vue?vue&type=template&id=59437a28&scoped=true&"
import script from "./DefaultHome.vue?vue&type=script&lang=js&"
export * from "./DefaultHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59437a28",
  null
  
)

export default component.exports